import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import enrollmentService from './enrollmentService';

const initialState = {
  enrollments: [],
  enrollment: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: '',
};

// Get user enrollments
export const getUserEnrollments = createAsyncThunk(
  'enrollments/getUserEnrollments',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await enrollmentService.getUserEnrollments(token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Enroll in a course
export const enrollInCourse = createAsyncThunk(
  'enrollments/enrollInCourse',
  async (courseId, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await enrollmentService.enrollInCourse(courseId, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get enrollment by ID
export const getEnrollmentById = createAsyncThunk(
  'enrollments/getEnrollmentById',
  async (enrollmentId, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await enrollmentService.getEnrollmentById(enrollmentId, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const enrollmentSlice = createSlice({
  name: 'enrollments',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
    clearEnrollment: (state) => {
      state.enrollment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get user enrollments cases
      .addCase(getUserEnrollments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserEnrollments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.enrollments = action.payload;
      })
      .addCase(getUserEnrollments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Enroll in course cases
      .addCase(enrollInCourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(enrollInCourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.enrollments.push(action.payload);
      })
      .addCase(enrollInCourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get enrollment by ID cases
      .addCase(getEnrollmentById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEnrollmentById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.enrollment = action.payload;
      })
      .addCase(getEnrollmentById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset, clearEnrollment } = enrollmentSlice.actions;
export default enrollmentSlice.reducer;